import { css, html, LitElement } from 'lit'
import { customElement, property, query } from 'lit/decorators.js'
import { countries } from './Countries'
import { Country, Dealer } from './Types'
import { DealerPopup } from './Popup'

@customElement('lindberg-dealers-baidu-map')
export class DealerMap extends LitElement {
	static styles = css`
		:host {
			display: block;
			container-type: size;
		}

		#container {
			width: 100%;
			height: 100cqh;
		}
	`

	@property({ type: Object })
	selectedCountry: Country | null = null

	@property({ type: Array })
	private _dealers: Dealer[] = []
	public get dealers(): Dealer[] {
		return this._dealers
	}
	public set dealers(value: Dealer[]) {
		this._dealers = value
		if(!this.map) return
		for(const dealer of value){			
			const marker = new BMapGL.Marker(new BMapGL.Point(dealer.properties.baiduLocation.longitude, dealer.properties.baiduLocation.latitude), {})
			marker.addEventListener("click", () => this.dispatchEvent(new CustomEvent('dealer-selected', { bubbles: true, detail: { dealer } })))
			this.map.addOverlay(marker)
		}

	}

	private popup:BMapGL.InfoWindow
	

	@property({ attribute: false })
	private _selectedDealer: Dealer | null = null

	public get selectedDealer(): Dealer | null {
		return this._selectedDealer
	}
	public set selectedDealer(value: Dealer | null) {		
		if(value == this.selectedDealer) return
		// if (this.map && value && value != this._selectedDealer) {
		this._selectedDealer = value
		const center = new BMapGL.Point(value.properties.baiduLocation.longitude, value.properties.baiduLocation.latitude)
		if(!this.map) return
		// if (this.popup) this.popup.setLngLat(center).addTo(this.map)
		this.map.centerAndZoom(center, Math.max(this.map.getZoom(), 10))
			// this.map.flyTo({ center, zoom, essential: true })
		// } else if (this.map && this.popup) {
		// 	this.popup.remove()
		// }
		if(!this.popup) this.popup = new BMapGL.InfoWindow(this.querySelector('lindberg-dealers-popup') as DealerPopup, {});  // 创建信息窗口对象
		
		this.map.openInfoWindow(this.popup, center);        // 打开信息窗口

	}

	@query('#container')
	private mapContainer?: HTMLDivElement

	private map?: BMapGL.Map
	private baiduLoader?: Promise<typeof BMapGL>

	private loadBaiduMap = () => {
		if (window.BMapGL) return Promise.resolve(window.BMapGL)
		if (this.baiduLoader) return this.baiduLoader

		const ak = import.meta.env.VITE_BAIDU_TOKEN
		if (!ak) throw new Error('Missing VITE_BAIDU_MAP_AK')

		this.baiduLoader = new Promise((resolve, reject) => {
			const callbackName = `__initBaiduMapGL__${Date.now()}`
			;(window as any)[callbackName] = () => {
				if (window.BMapGL) {
					resolve(window.BMapGL)
				} else {
					reject(new Error('BMapGL not available after callback'))
				}
				delete (window as any)[callbackName]
			}

			const script = document.createElement('script')
			script.src = `https://api.map.baidu.com/api?v=1.0&type=webgl&ak=${ak}&callback=${callbackName}`
			script.onerror = () => {
				reject(new Error('Failed to load Baidu Maps script'))
				delete (window as any)[callbackName]
			}
			document.head.appendChild(script)
		})

		return this.baiduLoader
	}

	connectedCallback(): void {
		const country = countries.find(x => x.code == "CN")
		this.dispatchEvent(new CustomEvent('country-selected', { bubbles: true, detail: { country } }))
		super.connectedCallback()

	}

	async firstUpdated() {
		if (!this.mapContainer) return


		const BMapGL = await this.loadBaiduMap()

		
		this.map = new BMapGL.Map(this.mapContainer)
	 	window["map"] = this.map


		this.map.enableScrollWheelZoom()
		// const [lng, lat] = wgs84ToBd09([lng, lat])

		this.map.setViewport([
			new BMapGL.Point(this.selectedCountry.bounds.west, this.selectedCountry.bounds.south), // lower-left
			new BMapGL.Point(this.selectedCountry.bounds.east, this.selectedCountry.bounds.north)  // upper-right
		])

		this.dealers = this._dealers
		// this.map.addEventListener("dragend", this.updateBounds.bind(this))
		this.map.addEventListener("zoomend", this.updateBounds.bind(this))
		this.map.addEventListener("moveend", this.updateBounds.bind(this))

	}
	updateBounds(){
		const bounds = this.map.getBounds()
		const ne = bounds.getNorthEast()
		const sw = bounds.getSouthWest()
		this.dispatchEvent(new CustomEvent('map-moved', { bubbles: true, detail: { bounds: { north: ne.lat, south: sw.lat, east: ne.lng, west: sw.lng}, zoom: this.map.getZoom() } }))

	}

	render = () => html`<slot></slot><div id="container"></div>`
}
